import {
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@mui/material";

export default function SkeletonTable() {
	return (
		<TableContainer sx={{ overflow: "unset" }}>
			<Table>
				<TableHead>
					<TableRow>
						{[...Array(2)].map((_, index) => (
							<TableCell key={index} />
						))}
					</TableRow>
				</TableHead>
				<TableBody>
					{[...Array(6)].map((_, index) => (
						<TableRow key={index}>
							{[...Array(2)].map((_, index) => (
								<TableCell align={index === 0 ? "left" : "center"} key={index}>
									<Skeleton variant='text' width={80} />
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
